/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  useMappingRulesQuery,
  MappingRulesFilterInput,
  MappingRulesSortInput,
} from "~/generated/graphql";

type Props = {
  sort?: MappingRulesSortInput;
  filter?: MappingRulesFilterInput;
};

export function useGetMappingRules({ sort, filter }: Props) {
  const { data, loading, error } = useMappingRulesQuery({
    variables: { sort, filter },
  });
  const count = data?.mappingRules.pageInfo?.count ?? 0;

  return {
    data: data?.mappingRules?.result ?? [],
    loading,
    error,
    count,
  } as const;
}
